import React from "react";
import Seo from "@/components/Seo";

const Cookies = () => {
  return (
    <>
      <Seo
        title="Cookies Policy"
        description="Cookies used by Calmbreeze (calmbreeze.co.uk) and how to manage your preferences."
        path="/cookies"
      />
      <section className="pt-[160px] pb-20 max-w-3xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="font-mono text-[11px] tracking-overline uppercase text-accent mb-6">[ Cookies Policy ]</div>
        <h1 className="font-display font-bold text-[2.5rem] md:text-[3.5rem] leading-[0.98] tracking-tightest mb-10">
          Cookies Policy
        </h1>
        <p className="text-[13px] text-muted-foreground mb-12">Last updated: January 2026.</p>

        <div className="prose-editorial">
          <h2>1. What cookies are</h2>
          <p>
            Cookies are small files stored on your device by your browser. They help the site work properly and let us
            understand how it is being used.
          </p>

          <h2>2. Cookies we use</h2>
          <ul>
            <li><strong>Strictly necessary</strong> — the cookie that remembers your cookie preference itself
              (<code>cb-cookie-consent</code>), the secure session cookies used by the admin dashboard, and
              standard CSRF protection.
            </li>
            <li><strong>Functional</strong> — none currently.</li>
            <li><strong>Analytics</strong> — none currently. If we add analytics in future, we will update this page and ask for your consent first.</li>
            <li><strong>Marketing / third-party</strong> — none.</li>
          </ul>

          <h2>3. Managing cookies</h2>
          <p>
            You can clear our consent cookie at any time by clicking &ldquo;Necessary only&rdquo; or &ldquo;Accept all&rdquo;
            in the banner that re-appears when you clear your browser data. You can also block or delete cookies through
            your browser settings.
          </p>

          <h2>4. More information</h2>
          <p>
            For more on cookies and how they work, see{" "}
            <a href="https://www.aboutcookies.org/" target="_blank" rel="noopener noreferrer">aboutcookies.org</a>.
            For any privacy or cookie question, email{" "}
            <a href="mailto:Hello@calmbreeze.co.uk">Hello@calmbreeze.co.uk</a>.
          </p>
        </div>
      </section>
    </>
  );
};

export default Cookies;
